import { get, post, put, remove } from "../../api_helper";
import * as url from "../../url_helper";

const baseURL = process.env.REACT_APP_API_DOTNET_URL;

export const createRandomDTLog = (payload) => post(baseURL + url.RANDOM_DT_LOG, payload);
export const getRandomDTLogDetails = (id) => get(`${baseURL + url.RANDOM_DT_LOG}/${id}`);
export const updateRandomDTLog = (id, payload) => put(`${baseURL + url.RANDOM_DT_LOG}/${id}`, payload);
export const deleteRandomDTLog = (id) => remove(`${baseURL + url.RANDOM_DT_LOG}/${id}`);